export const Settings = {
    version: '0.0.4'
}
